import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE__pds_ui_Select_mjs_4740d40f__ from "./pds-ui/Select.mjs";
const petCountOptions = [
    {
        label: 'None',
        value: '0'
    },
    {
        label: '1',
        value: '1'
    },
    {
        label: '2',
        value: '2'
    },
    {
        label: '3',
        value: '3'
    },
    {
        label: '4',
        value: '4'
    },
    {
        label: '5',
        value: '5'
    }
];
const PetCount = ({ petType, register, getValues, setValue, formState })=>{
    const petFieldName = `${petType}Count`;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__pds_ui_Select_mjs_4740d40f__.Select, {
        label: `# of ${petType}s`,
        "data-error": Boolean(formState.errors[petFieldName]),
        onValueChange: (value)=>{
            setValue(petFieldName, value, {
                shouldValidate: true,
                shouldDirty: true,
                shouldTouch: true
            });
        },
        ...register(petFieldName, {
            validate: {
                required: ()=>{
                    if (!getValues([
                        'catCount',
                        'dogCount'
                    ]).filter(Boolean).length) return `# of ${petType}s are required`;
                },
                invalid: (x)=>void 0 !== x
            }
        }),
        children: petCountOptions.map((item)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__pds_ui_Select_mjs_4740d40f__.SelectItem, {
                value: item.value,
                children: item.label
            }, item.label))
    });
};
const _components_PetCount = PetCount;
export { _components_PetCount as default };
